function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 7.167a3.33 3.33 0 01-2.756-1.458A4.163 4.163 0 003.916 8a3.333 3.333 0 012.897 4.828 4.169 4.169 0 002.374 0A3.333 3.333 0 0112.084 8a4.162 4.162 0 00-1.328-2.292A3.33 3.33 0 018 7.167zm0 7.5c.852 0 1.662-.183 2.392-.512a3.333 3.333 0 103.428-5.717 5.828 5.828 0 00-2.493-4.397 3.333 3.333 0 10-6.654 0A5.828 5.828 0 002.18 8.438a3.333 3.333 0 103.428 5.717c.73.329 1.54.512 2.392.512zM9.667 3.833a1.667 1.667 0 11-3.334 0 1.667 1.667 0 013.334 0zm-4.167 7.5a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0zm8.333 0a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0z",
  fill: "#fff"
});

var SvgIconRingGroup = function SvgIconRingGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 15"
  }), _ref);
};

export default SvgIconRingGroup;